import { createFileRoute, redirect } from '@tanstack/react-router';
import { EntityDocumentsLayout } from '@/app/(client)/my-styles/-components/EntityDocumentsLayout';
import { isEntityKindPath } from '@/app/(client)/my-styles/-hooks/useEntityDetail';
import { styleDocumentsQueryOptions } from '@/app/(client)/my-styles/-hooks/useStyleDocumentsQuery';
import { styleOrderDocumentsQueryOptions } from '@/app/(client)/my-styles/-hooks/useStyleOrderDocumentsQuery';
import { ensurePermissions } from '@/hooks/usePermissions';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/documents',
)({
  beforeLoad: async ({ params, location }) => {
    // Matches the backend guard on GET /style-documents (styles:read); the
    // tab is hidden in the tab bar too, but a deep-link would otherwise fetch
    // documents the user cannot see.
    const { styles } = await ensurePermissions();
    if (!styles.canRead) {
      throw redirect({
        to: '/my-styles/$kind/$id/overview',
        params: { kind: params.kind, id: params.id },
      });
    }
    const bare = `/my-styles/${params.kind}/${params.id}/documents`;
    if (location.pathname === bare || location.pathname === `${bare}/`) {
      throw redirect({
        to: '/my-styles/$kind/$id/documents/linked',
        params: { kind: params.kind, id: params.id },
      });
    }
  },
  loader: ({ params }) =>
    Promise.all([
      queryClient.ensureQueryData(
        styleOrderDocumentsQueryOptions(params.id, { page: 1, count: 20 }),
      ),
      queryClient.ensureQueryData(
        styleDocumentsQueryOptions(params.id, { page: 1, count: 20 }),
      ),
    ]),
  component: DocumentsRoute,
});

function DocumentsRoute() {
  const { kind, id } = Route.useParams();
  const safeKind = isEntityKindPath(kind) ? kind : 'styles';
  return (
    <EntityDocumentsLayout
      kind={safeKind}
      entityId={id}
      basePath='/my-styles'
    />
  );
}
